module.exports = __webpack_public_path__ + "img/CM-SS-25-Ford-Lifestyle.592b3581.jpg";